import MediaUrlField from './MediaUrlField/MediaUrlField';

const MediaUrlFieldDirective = (reactDirective, OpenGraphDataService) => {
  return reactDirective(
    MediaUrlField,
    undefined,
    { restrict: 'E' },
    { OpenGraphDataService }
  );
};

MediaUrlFieldDirective.$inject = ['reactDirective', 'OpenGraphDataService'];

export default MediaUrlFieldDirective;
